import template from './createSubcontractorModal.html';
import controller from './createSubcontractorModal.controller';

let CreateSubcontractorModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default CreateSubcontractorModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/createSubcontractorModal/createSubcontractorModal.component.js